import React from 'react';

const ArrowDownChunkySvg = (props) => (
    <svg
        className="arrow-down-chunky_svg__eds-icon--arrow-down-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="arrow-down-chunky_svg__eds-icon--arrow-down-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 4v12l-5.5-5.5L4 12l8 8 8-8-1.5-1.5L13 16V4z"
        />
    </svg>
);

ArrowDownChunkySvg.displayName = 'ArrowDownChunkySvg';
export default ArrowDownChunkySvg;
